<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Stock</strong>
          </CCardHeader>
          <CCardBody>
            <b-row class="row justify-content-md-center">

                <b-col md="2">
                  <b-form-group label="Establecimiento :">
                  <b-form-select  multiple v-model="id_establishment" :options="establishments" :select-size="1"></b-form-select>
                  </b-form-group>
                </b-col>
                
                 <b-col sm="12" md="5">
                  <b-form-group label="Proveedor">
                    <v-select @input="ListStockGeneral" placeholder="Todos" class="w-100" :filterable="false" label="name" v-model="provider" @search="SearchProvider" :options="providers"></v-select>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group label="Categoria" >
                      <b-form-select @change="ListStockGeneral" v-model="id_category" :options="categories"></b-form-select>
                    </b-form-group>
                </b-col>

                
                <b-col sm="6" md="2">
                  <b-form-group label=".">
                    <b-input-group>
                    <b-form-input @keyup="ListStockGeneral" v-model="search" class="form-control"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="primary" @click="ListStockGeneral"><b-icon icon="search"></b-icon></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="1">
                  <b-form-group label=".">
                    <b-button @click="GetProducts" title="Exportar a Excel" type="button" variant="success" class="form-control"><i class="fas fa-file-excel"></i></b-button>
                  </b-form-group>
                </b-col>

                <!-- <b-col md="2" v-if="alternative_reports == 'SI'">
                  <b-form-group>
                    <b-button @click="ExportDataTable" title="Exportar a Excel" type="button" variant="warning" class="form-control"><i class="fas fa-file-excel"></i> Generar Reporte</b-button>
                  </b-form-group>
                </b-col> -->

            </b-row>

            <div class="table-responsive mt-3 height-table">
              <table class="table table-hover table-bordered table-scroll-horizontal">
                <thead>
                  <tr>
                    <th rowspan="2" width="5%" class="text-center">#</th>
                    <th rowspan="2" width="8%" class="text-center">Codigo</th>
                    <th rowspan="2" width="40%" class="text-center">Nombre</th>
                    <th rowspan="2" width="10%" class="text-center">Categoria</th>
                    <th rowspan="2" width="10%" class="text-center">Marca</th>
                    <th :colspan="item.quantity" width="10%" class="text-center" v-for="(item, it) in mestablishments" :key="it">{{ item.name }}</th>
                    <th rowspan="2" width="5%" class="text-center">Total</th>
                  </tr>
                  <tr>
                    <th class="text-center" v-for="(item, it) in mwarehouses" :key="it">{{ item.name }}</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in data_table" :key="it">
                  <tr>
                    <td class="text-center">{{ it + 1 }}</td>
                    <td class="text-center"> {{ item.code }}</td>
                    <td class="text-left"> {{ item.name + " - "+item.presentation }}</td>
                    <td class="text-left"> {{ item.category_name }}</td>
                    <td class="text-left"> {{ item.brand_name }}</td>
                    <td class="text-right" v-for="(stock, it1) in item.stock" :key="it1">
                       {{stock.quantity}}
                    </td>
                    <td class="text-right"> {{ item.total_stock }}</td>
                
                  </tr>
                </tbody>
              </table>
            </div>
            <b-row class="mt-4">
              <b-col md="8">
                <b-pagination v-model="currentPage" v-on:input="ListStockGeneral" :total-rows="rows" :per-page="perPage" align="center"></b-pagination>
              </b-col>
              <b-col md="4 text-center">
                <p>Pagina Actual: {{ currentPage }}</p>
              </b-col>
            </b-row>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <LoadingComponent :is-visible="isLoading"/>
  </div>
</template>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";

import CodeToName from "@/assets/js/CodeToName";
import LoadingComponent from './../pages/Loading'

export default {
  name: "RquirementList",
  components:{
    vSelect,
    LoadingComponent,
  },
  data() {
    return {
      isLoading: false,
      module: 'Stock',
      perPage: 15,
      currentPage: 1,
      rows: 0,
      data_table: [],
      establishments:[],
      mestablishments:[],
      mwarehouses:[],
      id_establishment:['all'],
      search: "",
      providers: [],
      provider:null,
      categories:[],
      id_category:'all',

      batch_size: 50,
      lotes: [],
      unique_id:"",

      errors:{
        to:false,
        from:false,
      }
    };
  },
  mounted() {
    this.ListEstablishment();
    this.ListCategories();
    this.ListStockGeneral();
  },
  methods: {
    ListStockGeneral,
    ListEstablishment,

    Permission,

    SearchProvider,
    ListCategories,

    CodeInvoice,
    Substr,

    ExportExcel,
    ExportDataTable,

    GetProducts,
    SaveStockGeneral,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    alternative_reports: function () {
      let alternative_reports = window.localStorage.getItem("alternative_reports");
      return alternative_reports;
    },
  },
};
function SearchProvider(search, loading) {
  
    let me = this;
    let url = this.url_base + "search-providers/" + search;
    if (search !== "") {
      loading(true);
      axios({
        method: "GET",
        url: url,
      }).then(function (response) {
            me.providers = response.data.result;
            loading(false);
      })
    }
    
}

function ListCategories() {
  let me = this;
  let url = this.url_base + "active-categories";

  axios({
    method: "GET",
    url: url,
    headers: {
      token: this.token,
    },
  })
    .then(function (response) {
      me.categories = [{value:'all',text:'-- Todos --'}];
      if (response.data.status == 200) {
        for (let index = 0; index < response.data.result.length; index++) {
          const element = response.data.result[index];
           me.categories.push({value:element.id_category,text:element.name});
        }
       
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}


function ListEstablishment() {

  let me = this;
  let url = this.url_base + "active-establishments";
  axios({
    method: "GET",
    url: url,
    headers: { token: me.token, module: me.module, role: me.role,},
  })
    .then(function (response) {
      me.establishments = [{value:'all',text:'Todos'}];
      if (response.data.status == 200) {
        for (let index = 0; index < response.data.result.length; index++) {
          const element = response.data.result[index];
          me.establishments.push({value: element.id_establishment, text: element.name});
        }
      } else {
        Swal.fire({ icon: 'error', text: 'A Ocurrido un error', timer: 2000,})
      }
    })
}



function CodeInvoice(code) {
  return CodeToName.CodeInvoice(code);
}
function Substr(name,limit) {
  if (name.length > limit ) {
    return name.substr(0,limit)+'...';
  }else{
    return name;
  }
}
//listar usuario
function ListStockGeneral() {


  let search = this.search == "" ? "all" : this.search;
  let id_provider = this.provider == null ? 'all':this.provider.id;
  this.id_establishment = this.id_establishment.length > 0 ? this.id_establishment : ['all'];
  let me = this;
  let url = this.url_base + "kardex/stock-general";
  let data = {
    id_establishment: this.id_establishment,
    id_provider: id_provider,
    id_category: this.id_category,
    search: search,
    page: this.currentPage,
  }

  axios({
    method: "POST",
    url: url,
    data: data,
    headers: { token: this.token, module: this.module,role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.rows = response.data.result.table.total;
        me.data_table = response.data.result.stock;
        me.mestablishments = response.data.result.establishments;
        me.mwarehouses = response.data.result.warehouses;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}


function ExportExcel() {
  let url = this.url_base + "excel-kardex-stock-general/"+this.unique_id;
  window.open(url,'_blank');
}



function ExportDataTable() {


let search = this.search == "" ? "all" : this.search;
let id_provider = this.provider == null ? 'all':this.provider.id;
let url = this.url_base + "data-table-kardex-stock-general/"+this.id_establishment+"/"+id_provider+"/"+this.id_category +"/"+ search;

window.open(url,'_blank');
}

function GetProducts() {
  this.isLoading = true;
  let me = this;
  let url = this.url_base + "get-lotes-products";
  me.products = [];
  me.lotes = [];
  axios({
    method: "POST",
    url: url,
    data: {
      search: me.search == "" ? "all" : me.search,
      id_category: me.id_category,
      id_provider: me.provider == null ? 'all':me.provider.id,
      loteSize: me.batch_size,
    },
    headers: { token: this.token, module: this.module, role: 1 },
  })
  .then(function (response) {
    if (response.data.status == 200) {
      me.lotes = response.data.result;
      console.log(me.lotes);
      me.SaveStockGeneral();
    }else{
      Swal.fire({ icon: "error", text: "A ocurrido un error", timer: 3000 });
      me.isLoading = false;
    }
    // me.isLoading = false;
  })
  .catch(() => {
    Swal.fire({ icon: "error", text: "A ocurrido un error", timer: 3000 });
    me.isLoading = false;
  });
}

async function SaveStockGeneral() {
  let me = this;
  const lotes = this.lotes;
  this.id_establishment = this.id_establishment.length > 0 ? this.id_establishment : ['all'];
  me.unique_id = Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000;
  console.log('num lotes : '+lotes.length)
  me.isLoading = true;
  var index = 1;
  for (const lote of lotes) {
    try {
      let url = this.url_base +"kardex/save-stock-general";
      const response = await axios({
        method: "POST",
        url: url,
        data: { 
          products : lote, 
          unique_id: me.unique_id,
          id_establishment: me.id_establishment,
        },
        headers: { token: this.token, module: this.module, role: 1},
      });
       console.log('Lote: '+index, response.data.result); // Laravel envía los productos paginados dentro de "data"
       index ++;
    } catch (error) {
      me.isLoading = false;
      console.error("Error al enviar el lote:", error);
      Swal.fire({ 
        icon: 'error', 
        text: 'Ocurrió un error al procesar los datos, Intente nuevamente.', 
        confirmButtonText: 'Cerrar'
      });
      return;
    }
  }

  me.isLoading = false;
  me.ExportExcel();
}

// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>
